import { InferGetStaticPropsType } from "next";
import { ReactNode } from "react";

import { AppLayout } from "shared/Layout";
import { fetchSettings } from "shared/SettingsProvider/settings.helper";
import { CACHE_ONE_DAY } from "utils/config.utils";
import { withApp } from "utils/with-app.utils";
import { fetchTranslations } from "utils/with-i18n.utils";
import { withSeo } from "utils/with-seo.utils";

import { HeroSection, ReferralPicture } from "./HeroSection";
import { HowItWorksSection } from "./HowItWorksSection";

export const ReferralPage = ({
  settings,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const referralPicture: ReferralPicture = {
    desktop: settings.referralPictureDesktop,
    mobile: settings.referralPictureMobile,
  };

  return (
    <>
      <HeroSection {...referralPicture} />
      <HowItWorksSection />
    </>
  );
};

ReferralPage.getLayout = (page: ReactNode, pageProps: any) => (
  <AppLayout {...pageProps}>{page}</AppLayout>
);

export const getStaticProps = async () => {
  const translations = await fetchTranslations(["referral", "breadcrumb"]);

  return {
    props: {
      translations,
      settings: await fetchSettings(),
    },
    revalidate: CACHE_ONE_DAY,
  };
};

export default withApp(ReferralPage, [withSeo]);
